import { onBeforeMount } from 'vue'

import { AdServiceOptions } from '@/modules/adv/ad-service'
import { useAdsStore } from '@/store/ads-store'

export const useSetPageData = (updateTargeting: () => AdServiceOptions['targeting'] | undefined) => {
    const adsStore = useAdsStore()

    // eslint-disable-next-line no-restricted-syntax
    onBeforeMount(() => {
        const targeting = updateTargeting()
        if (targeting) {
            adsStore.updateTargeting(targeting)
        }
    })
}
